<nav
    class="navbar navbar-expand-lg bg-ermes-nav"
    [style.backgroundColor]="navbarColor"
>
    <a class="nav-link" routerLink="/home">
        <mat-icon svgIcon="icon_logo" class="logo-ens"></mat-icon>
        <span class="navbar-brand">{{ titleNavBar }}</span>
    </a>
    <!-- <button class="navbar-toggler order-first" type="button" data-toggle="collapse" data-target="#navbarMenu"
        aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button> -->
    <div class="collapse navbar-collapse collpase__ordered" id="navbarMenu">
        <!-- <ul class="navbar-nav mr-auto">
            <li class="nav-item"><a class="nav-link" routerLink="/home">Home</a></li>
        </ul> -->
    </div>
    <div>
        <div class="navbar-actions">
            <button
                type="button"
                class="fo-theme-switch"
                role="switch"
                [attr.aria-checked]="isDarkTheme"
                [attr.aria-label]="isDarkTheme ? 'Passa al tema chiaro' : 'Passa al tema scuro'"
                [title]="isDarkTheme ? 'Passa al tema chiaro' : 'Passa al tema scuro'"
                (click)="toggleTheme()"
            >
                <span class="fo-theme-switch__track">
                    <span class="fo-theme-switch__thumb">
                        <mat-icon>{{ isDarkTheme ? "brightness_2" : "wb_sunny" }}</mat-icon>
                    </span>
                </span>
            </button>

            <button
                mat-button
                [matMenuTriggerFor]="moreMenu"
                [ngClass]="{ logged: userLogged }"
                class="account-button"
            >
                <div *ngIf="userLogged" class="icon_logged">
                    <span>{{ user?.userdata?.name }}</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                </div>
                <div *ngIf="!userLogged">
                    <mat-icon *ngIf="!userLogged">more_vert</mat-icon>
                </div>
            </button>
            <mat-menu
                #moreMenu="matMenu"
                class="fo-theme-menu"
                [overlapTrigger]="false"
            >
                <button
                    mat-menu-item
                    fxLayout="row"
                    fxLayoutAlign="left center"
                    [routerLink]="['/home']"
                >
                    <mat-icon svgIcon="icon_logo" class="logo-ens"></mat-icon>
                    <span>Home</span>
                </button>
                <div *ngIf="userLogged">
                    <button
                        mat-menu-item
                        fxLayout="row"
                        fxLayoutAlign="left center"
                        (click)="edit_profile()"
                    >
                        <mat-icon>account_circle</mat-icon>
                        <span>Modifica Profilo</span>
                    </button>
                    <button
                        mat-menu-item
                        fxLayout="row"
                        fxLayoutAlign="left center"
                        (click)="change_password()"
                    >
                        <mat-icon>lock</mat-icon>
                        <span>Cambia Password</span>
                    </button>
                </div>
                <button
                    mat-menu-item
                    *ngIf="showExtraMenu"
                    fxLayout="row"
                    fxLayoutAlign="left center"
                    (click)="useCondition()"
                >
                    <mat-icon>chrome_reader_mode</mat-icon>
                    <span>Regolamento</span>
                </button>
                <button
                    mat-menu-item
                    *ngIf="showExtraMenu"
                    fxLayout="row"
                    fxLayoutAlign="left center"
                    (click)="privacy()"
                >
                    <mat-icon>remove_red_eye</mat-icon>
                    <span>Privacy</span>
                </button>

                <button
                    mat-menu-item
                    *ngIf="showExtraMenu"
                    fxLayout="row"
                    fxLayoutAlign="left center"
                    (click)="cookie()"
                >
                    <mat-icon>sentiment_satisfied_alt</mat-icon>
                    <span>Cookies</span>
                </button>

                <div *ngIf="userLogged">
                    <button
                        mat-menu-item
                        fxLayout="row"
                        fxLayoutAlign="left center"
                        (click)="logout()"
                    >
                        <mat-icon>exit_to_app</mat-icon>
                        <span>Logout</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </div>
</nav>
